import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-project",
  "use": "icon-project-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-project\"><path d=\"M892.8 120.32H758.4V77.696a44.8 44.8 0 0 0-89.6 0v42.624H355.2V77.696a44.8 44.8 0 0 0-89.6 0v42.624H131.2a65.856 65.856 0 0 0-67.2 64v682.688a65.856 65.856 0 0 0 67.2 64h761.6a65.856 65.856 0 0 0 67.2-64V184.32a65.856 65.856 0 0 0-67.2-64z m-291.2 512H243.2a42.688 42.688 0 1 1 0-85.313h358.4a42.688 42.688 0 1 1 0 85.313z m179.2-213.31H243.2a42.688 42.688 0 1 1 0-85.313h537.6a42.688 42.688 0 1 1 0 85.312z\" p-id=\"9147\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/project.svg
// module id = 6CSd
// module chunks = 77